export const state = {
  // product: undefined,
  // products: []
  article: {},
  articles: [],
  pagination:''
}
